import { writable } from 'svelte/store';

export const lotWid = writable(100),
						 lotLen = writable(200),
						 lotFace = writable(30),
						 lotSide = writable(10),
						 lotRear = writable(10),
						 buildLen = writable(0),
						 buildWid = writable(0);

export const rectArea = (w, h) => {
	let area = w * h;
	return area < 0 ? 0 : area;
}
